import React from "react";
import { FmCarbonTableHeaderRow } from "./FmCarbonTableHeaderRow";
import { FmCarbonTableContentRow } from "./FmCarbonTableContentRow";
import { useDispatch, useSelector } from "react-redux";
import { AgriSolutionState, RootState } from "../../Redux";
import { ShowWhen } from "../ShowWhen";
import { useTheme } from "../../Hooks";
import { FmCarbonIndexDialog } from "./FmCarbonIndexDialog";
import { Stack } from "@mui/material";

export const FmCarbonFootprintTable = () => {
    const isTableOpen = useSelector((state: RootState) => state.agriSolution.releaseGraphState.isCarbonTableOpen);
    const dispatch = useDispatch();
    const theme = useTheme();
    const carbonFootprintData = useSelector((state: RootState) => state.cfpTable.tableData);

    return (
        <div style={{ position: "relative" }}>
            {/* Table Header */}
            <FmCarbonTableHeaderRow />

            {/* Full Table Content  */}
            <ShowWhen when={isTableOpen}>
                <div>
                    {carbonFootprintData.map((e, idx) => (
                        <FmCarbonTableContentRow key={e.environmentalParameter + "_key"} isLastChild={idx == carbonFootprintData.length - 1} {...e} />
                    ))}
                </div>

                <img
                    src={theme.images.carbonTableLeaf}
                    alt=''
                    style={{
                        position: "absolute",
                        bottom: 79,
                        left: "32%",
                        opacity: 0.3,
                        userSelect: "none",
                        pointerEvents: "none",
                    }}
                    draggable={false}
                />
            </ShowWhen>

            {/* Partial Table Content  */}
            <ShowWhen when={!isTableOpen}>
                <FmCarbonTableContentRow {...carbonFootprintData[0]} />
            </ShowWhen>

            <Stack width='100%' direction='row' justifyContent='flex-end'>
                <img src={theme.images.simaproLogo} alt='powered by sima pro' height='40' />
            </Stack>

            {/* Table View Mode */}
            <div
                style={{
                    fontSize: 16,
                    fontWeight: 400,
                    textDecoration: "solid underline",
                    cursor: "pointer",
                    margin: "14px 0",
                }}
                onClick={() => dispatch(AgriSolutionState.Actions.toggleCarbonTable(!isTableOpen))}
            >
                {isTableOpen ? "See Less" : "See More"}
            </div>

            {/* Index Rate Dialog */}
            <FmCarbonIndexDialog />
        </div>
    );
};
